// extracted by mini-css-extract-plugin
export default {"btnGroup":"ButtonGroup_btnGroup__n55JS","iconSize":"ButtonGroup_iconSize__gPcxu","btn2":"ButtonGroup_btn2__XRNRx","btn1":"ButtonGroup_btn1__vKbrh"};